import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { ProfileService } from '../../../services/profile.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-profile-connections',
  templateUrl: './profile-connections.component.html',
  styleUrls: ['./profile-connections.component.scss']
})
export class ProfileConnectionsComponent implements OnInit {
    pagecode: string = "profile-connections";
    module: string = "profile";
    accessdenied: boolean = false;
    constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private profileService: ProfileService,
        private authentication: AuthenticationService,
        private common: CommonService) {

    }

    ngOnInit(): void {

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {


                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        this.getUserConnectionList();
                        this.getUserConnectionYouMayKnow();
                        this.getUserSentConnectionList();
                        this.getUserRequestedConnectionList();

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });


    }

    myConnectionShowLoading: boolean = false;
    pageSizeSearch: any = 6;
    findConnectionTxt: string = "";
    searchLoading: boolean = false;
    findConnection() {
        if (this.findConnectionTxt != '') {
            this.searchForUser(this.findConnectionTxt);
        }
        else {
            //this.toastr.error('Type user name or email address');
        }
    }
    moreSearch() {
        this.pageSizeSearch = this.pageSizeSearch + 6;
    }
    searchResult: any[] = [];
    searchForUser(search: any) {

        this.searchResult = [];
        this.pageSizeSearch = 6;
        if (search != '') {

            this.searchConnection(search, this.authentication.userData.portalAccount.id, this.authentication._authentication.id);
        }
        else {
            //this.toastr.info('Please specify the name or email of connection to search!', 'Oops');
        }

    }
    searchConnection(text: any, userAccountId: any, userId: any) {
        this.searchLoading = true;
        this.profileService.searchConnection(text, userAccountId, userId).subscribe(
            (res: any) => {
                this.searchResult = res;
                this.searchLoading = false;
            },
            (err: any) => {
                this.searchLoading = false;
            }
        );
    }
    findEnter(evt: any) {
        if (evt.keyCode === 13) {
            // Cancel the default action, if needed
            event!.preventDefault();
            // Trigger the button element with a click
            this.findConnection();
        }
    }
    sendConnectionRequestInvitation(item: any, index: any) {
        this.profileService.sendConnectionRequestInvitation(this.authentication._authentication.id, item.id).subscribe(
            (res: any) => {
                if (res) {
                    this.searchResult.splice(index, 1);
                    this.sentConnection.push(item);
                }
                else
                    this.common.ShowMessage('info', 'something went wrong, please try again later', '');
            },
            (err: any) => {
                console.error("sendConnectionRequestInvitation()", err);
            }
        );

    }
    sendInvitation(item: any, index: any) {
        if (item.email != '') {
            if (item.email === undefined) {
                //this.toastr.error('Email Address should be in Email format!', 'Oops');

            }

            else {
                this.profileService.sendUserInvitation(this.authentication._authentication.id, item.email).subscribe(
                    (res: any) => {
                        this.searchResult.splice(index, 1);
                    },
                    (err: any) => {
                        console.error("sendInvitation err", err);
                    }
                );
            }
        }
        else {
            // this.toastr.error('Email Address is Mandatory!', 'Oops');
        }


    }

    sendConnectionRequestInvitationConnectionYouMayKnow(item: any, index: any) {
        this.profileService.sendConnectionRequestInvitation(this.authentication._authentication.id, item.id).subscribe(
            (res: any) => {
                if (res) {
                    this.connectionYouMayKnow.splice(index, 1);
                    this.sentConnection.push(item);
                }
                else
                    this.common.ShowMessage('info', 'something went wrong, please try again later', '');
            },
            (err: any) => {
                console.error("sendConnectionRequestInvitationConnectionYouMayKnow()", err);
            }
        );
    }

    connectionYouMayKnow: any[] = [];
    pageSizeYouMayKnow: any = 6;
    getUserConnectionYouMayKnow() {

        this.profileService.getUserConnectionYouMayKnow(this.authentication._authentication.id, this.authentication.userData.portalAccount.id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.connectionYouMayKnow = res.data;
                }
            },
            (err: any) => {
                console.error("getUserConnectionList err", err);
            }
        );


    }
    moreYouMayKnow() {
        this.pageSizeYouMayKnow = this.pageSizeYouMayKnow + 6;
    }

    myConnection: any[] = [];
    getUserConnectionList() {

        this.myConnectionShowLoading = true;
        this.profileService.getUserConnectionList(this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.myConnection = res.data;
                }
                this.myConnectionShowLoading = false;
            },
            (err: any) => {
                console.error("getUserConnectionList err", err);
                this.myConnectionShowLoading = false;
            }
        );
    }

    sentConnection: any[] = [];
    mySentConnectionShowLoading: boolean = false;

    getUserSentConnectionList() {
        this.mySentConnectionShowLoading = true;
        this.profileService.getUserSentConnectionList(this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.sentConnection = res.data;
                }
                this.mySentConnectionShowLoading = false;
            },
            (err: any) => {
                console.error("getUserSentConnectionList err", err);
                this.mySentConnectionShowLoading = false;
            }
        );
    }


    requestedConnection: any[] = [];
    myRequestedConnectionShowLoading: boolean = false;

    getUserRequestedConnectionList() {
        this.myRequestedConnectionShowLoading = true;
        this.profileService.getUserRequestedConnectionList(this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success) {
                    this.requestedConnection = res.data;
                }
                this.myRequestedConnectionShowLoading = false;
            },
            (err: any) => {
                console.error("getUserRequestedConnectionList err", err);
                this.myRequestedConnectionShowLoading = false;
            }
        );
    }

    openUserProfile(profileUserId: any) {
        this.router.navigate(['/profile/user-profile/' + profileUserId]);
    }
    sentConnectionRequests: any[] = [];
    myConnectionRequests: any[] = [];

    fillConnections(connections: any) {


        if (connections) {
            this.myConnection = [];
            for (var i = 0; i < connections.myConnection.length; i++) {
                if (connections.myConnection[i].isActive) {
                    //connections.myConnection[i].contactLogo = "url('" + connections.myConnection[i].contactLogo + "')";
                    //this.myConnection.push(connections.myConnection[i]);
                    this.myConnection.push({
                        contactLogo: connections.myConnection[i].contactLogo,
                        contactName: connections.myConnection[i].firstName + ' ' + connections.myConnection[i].lastName,
                        contactOrganization: "",
                        contactTitle: connections.myConnection[i].title.trim(),
                        id: connections.myConnection[i].id
                    });
                }
            }
            this.sentConnectionRequests = [];
            for (var i = 0; i < connections.sentConnectionRequests.length; i++) {
                if (connections.sentConnectionRequests[i].toPortalUser.isActive) {
                    //connections.sentConnectionRequests[i].toPortalUser.contactLogo = "url('" + connections.sentConnectionRequests[i].toPortalUser.contactLogo + "')";
                    //this.sentConnectionRequests.push(connections.sentConnectionRequests[i]);
                    this.sentConnectionRequests.push({
                        contactLogo: connections.sentConnectionRequests[i].toPortalUser.contactLogo,
                        contactName: connections.sentConnectionRequests[i].toPortalUser.firstName + ' ' + connections.sentConnectionRequests[i].toPortalUser.lastName,
                        contactOrganization: "",
                        contactTitle: connections.sentConnectionRequests[i].toPortalUser.title,
                        id: connections.sentConnectionRequests[i].toPortalUser.id
                    });
                }
            }
            this.myConnectionRequests = [];
            for (var i = 0; i < connections.myConnectionRequests.length; i++) {
                if (connections.myConnectionRequests[i].requestedPortalUser.isActive) {
                    //connections.myConnectionRequests[i].requestedPortalUser.contactLogo = "url('" + connections.myConnectionRequests[i].requestedPortalUser.contactLogo + "')";
                    //this.myConnectionRequests.push(connections.myConnectionRequests[i]);
                    this.myConnectionRequests.push(
                        {
                            contactLogo: connections.myConnectionRequests[i].requestedPortalUser.contactLogo,
                            contactName: connections.myConnectionRequests[i].requestedPortalUser.firstName + ' ' + connections.myConnectionRequests[i].requestedPortalUser.lastName,
                            contactOrganization: "",
                            contactTitle: connections.myConnectionRequests[i].requestedPortalUser.title,
                            id: connections.myConnectionRequests[i].requestedPortalUser.id
                        }
                    );
                }
            }

        }
    }

}
